import cn from 'clsx'
import { Box } from '@/components/Box/Box'
import { Hidden } from '@/components/hidden/hidden'

import css from './customer-logos.module.css'

export type CustomerLogosProps = {
    color?: 'primary' | 'secondary' | 'tertiary'
    blockSize?: number
    logos: React.ReactElement[]
}

export function CustomerLogos({ color = 'tertiary', blockSize = 56, logos }: CustomerLogosProps) {
    return (
        <Box
            className={cn(css.container, css[color])}
            style={{ '--block-size': `${blockSize}px` } as React.CSSProperties}
        >
            <Box className={css.inner}>
                {logos}
                <Hidden above="lg">
                    {logos}
                    {logos}
                </Hidden>
            </Box>
        </Box>
    )
}
